<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header liga-float-header reset-header">
      <ion-toolbar class="reset-float-toolbar">
        <div class="liga-float-bar reset-float-bar">
          <button type="button" class="liga-float-circle" aria-label="Назад" @click="navigate('login')">
            <ion-icon :icon="arrowBackOutline" />
          </button>
          <div class="liga-float-title-pill">
            <span class="liga-float-title-text">Сброс пароля</span>
          </div>
          <div class="liga-float-spacer" aria-hidden="true" />
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background" :fullscreen="true" :scroll-y="true">
      <ion-card class="reset-card bg-transparent">
        <ion-card-content>
          <ion-input type="email" inputmode="email" placeholder="Электронная почта" v-model="email"></ion-input>
          <div class="main-button-container">
            <ion-button v-on:click="resetPassword()" class="reset-button">
              OK
            </ion-button>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from '@/model/globalcontext.model';
import router from '@/router/index';
import { stripAuthWhitespace } from '@/utils/auth-input';
import { CapacitorHttp } from '@capacitor/core';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonPage,
  IonToolbar,
  alertController,
} from '@ionic/vue';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent, inject } from 'vue';

export default defineComponent({
  props: {
    timeout: { type: Number, default: 1000 },
  },
  name: 'ResetPassword',
  components: {
    IonContent,
    IonPage,
    IonHeader,
    IonToolbar,
    IonCard,
    IonCardContent,
    IonInput,
    IonButton,
    IonIcon,
  },
  setup() {
    const emailPattern = new RegExp('[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})');
    const globalContext = inject('globalContext') as GlobalContext;
    const isMobile = globalContext.isMobile;

    return {
      arrowBackOutline,
      emailPattern,
      isMobile,
    }
  },
  data() {
    return {
      email: '',
    }
  },

  ionViewWillEnter() {
    this.email = '';
  },

  methods: {
    navigate(routeName: string): void {
      router.push(`/${routeName}`);
    },

    resetPassword(): void {
      const email = stripAuthWhitespace(this.email).toLowerCase();
      this.email = email;
      if (email.length < 1 || !this.emailPattern.test(email)) {
        this.showAlert('Ошибка', 'Укажите корректный адрес электронной почты');
        return;
      }

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/account/force-reset-password/init`,
        data: email,
        headers: {
          'Content-Type': 'application/json'
        }
      };

      CapacitorHttp.post(options)
        .then((response) => {
          if (response.status === 400) {
            this.showAlert('Ошибка', 'Попробуйте другой email');
          } else {
            this.showAlert('Сообщение', 'Пароль успешно сброшен. Пожалуйста, проверьте почту.');
            this.navigate('login');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController
        .create({
          header: alertTitle,
          message: alertMessage,
          buttons: ['OK'],
        });

      await alert.present();
    }
  }
});
</script>

<style scoped>
.reset-float-toolbar {
  --background: transparent;
  --border-width: 0;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: env(safe-area-inset-top);
  --min-height: 56px;
}
.reset-float-bar .liga-float-circle {
  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: var(--liga-chrome-text);
  flex-shrink: 0;
}
.reset-float-bar .liga-float-circle ion-icon {
  font-size: 22px;
  color: var(--liga-chrome-text);
}
.reset-float-bar .liga-float-spacer {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}

.reset-card {
  margin: 24px 12px;
  box-shadow: none;
}

ion-input {
  --background: var(--liga-float-glass-bg-strong);
  --color: var(--liga-chrome-text);
  --placeholder-color: var(--liga-chrome-text-muted);
  border-radius: 25px;
  font-family: 'Montserrat';
  margin-bottom: 2em;
  --padding-start: 2em;
  --padding-end: 2em;
  border: 1px solid var(--liga-float-glass-border);
  box-shadow: var(--liga-float-glass-shadow);
}

.reset-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  --color: #ffffff;
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.main-button-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
</style>